import { ITransaccion } from "./ITransaccion";
export class TransaccionModel implements ITransaccion {
  tx:boolean = false;
  error?:any// si es que hay error,
  data?:any//datos que se retornan
}
